import { Box, Card, IconButton, Typography } from '@mui/material';
import React from 'react';
import IconBox from 'components/IconBox';
import Image from 'components/Image';
import { Icon } from '../index';
import { CardButtonProps } from './types';

const CardButton = ({
  title,
  description,
  onClick,
  selected,
  disabled,
  icon,
  iconColor,
  iconBackground,
  iconBoxSize,
  onIconClick,
  image,
  reverseTitleDescription = false,
  titleTypographyVariant = 'h2',
  descriptionTypographyVariant = 'body1',
  secondaryAction,
  backgroundColor = '#FFF'
}: CardButtonProps) => {
  return (
    <Card
      onClick={event => {
        if (!disabled && onClick) {
          onClick();
        }
      }}
      component="button"
      variant="outlined"
      sx={theme => ({
        // p: 0,
        display: 'flex',
        justifyContent: 'start',
        mb: 2,
        width: '100%',
        cursor: 'pointer',
        textAlign: 'left',
        opacity: disabled ? 0.5 : 1,
        borderRadius: '12px',
        border: '1px solid rgba(182, 182, 182, 0.30)',
        background: backgroundColor,
        alignItems: 'center',
        transition: theme.transitions.create(['box-shadow', 'border-color'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.standard
        }),
        // borderWidth: 2,
        '&:hover': {
          // borderColor: theme.palette.primary.main,
          // boxShadow: '0px 8px 24px 0px rgba(131, 60, 226, 0.16);'
          boxShadow: '0px 8px 24px 0px rgba(131, 60, 226, 0.16)'
        },
        ...(selected && {
          borderColor: theme.palette.primary.main,
          // boxShadow: '0px 8px 24px 0px rgba(131, 60, 226, 0.16);'
          boxShadow: '0px 8px 24px 0px rgba(131, 60, 226, 0.16)'
        })
      })}
    >
      {icon && (
        <Box
          sx={{ alignSelf: 'center', marginLeft: '12px' }}
          py={description ? 0 : '12px'}
          onClick={event => {
            event.stopPropagation();
            if (!disabled && onIconClick) {
              onIconClick();
            }
          }}
        >
          <IconBox boxSize={iconBoxSize} iconBackground={iconBackground} icon={icon} iconColor={iconColor} />
        </Box>
      )}
      {image && (
        <Box sx={{ alignSelf: 'center', marginLeft: '12px' }} py={description ? 0 : '12px'}>
          <Image image={image} width={iconBoxSize || 32} />
        </Box>
      )}
      <Box
        py={'12px'}
        marginLeft={'12px'}
        sx={{ display: 'flex', flexDirection: reverseTitleDescription ? 'column-reverse' : 'column', width: '100%' }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: description ? '4px' : 0 }}>
          <Typography variant={titleTypographyVariant} component="div" sx={{ textTransform: 'capitalize' }}>
            {title}
          </Typography>
          {disabled ? (
            <Typography
              variant={'body1'}
              component="div"
              sx={{
                textTransform: 'capitalize',
                color: '#833CE2',
                borderRadius: '12px',
                padding: '2px 8px',
                background: 'rgba(131, 60, 226, 0.10)'
              }}
            >
              Coming Soon
            </Typography>
          ) : null}
        </Box>
        {description && (
          <Typography variant={descriptionTypographyVariant} component="div" sx={{ opacity: '0.6' }}>
            {description}
          </Typography>
        )}
      </Box>
      {secondaryAction && (
        <Box
          onClick={event => {
            event.stopPropagation();
          }}
          sx={{ marginLeft: 'auto' }}
        >
          {secondaryAction}
        </Box>
      )}
    </Card>
  );
};

export default CardButton;
